// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.c-chart-brand[data-v-1406269c] {\n  position: absolute;\n  width: 100%;\n  height: 100px;\n}\n", ""]);
// Exports
module.exports = exports;
